export interface EventMessageData {
  _messageId?: number;
  _roomId?: string;
  [key: string]: any;
}


export interface UpdateEventMessageData extends EventMessageData {
  path: string;
  method: string;
  entity: any;
}

export enum NotifierConnectionStatus {
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
  ERROR = "error",
  UNKNOWN = "unknown",
  RECONNECTING = "reconnecting",
  AUTHENTICATED = "authenticated",
  UNAUTHENTICATED = "unauthenticated",
} 
export interface NotifierState {
  socketId: string | null;
  lastMessageTimestamp: number;
  connectionStatus: NotifierConnectionStatus;
}